import * as actionTypes from "./actionTypes";
import { updateObject } from "../../util/updateObject";
import { initialCreateFasceData, initialSelectedFasce } from "./helper";

const initialState = {
  fasceOrarie: {
    data: [],
    lastUpdated: "",
    loading: false,
  },
  createFasceOrarie: initialCreateFasceData,
  selectedFasceOrarie: initialSelectedFasce,
  createFasceOrarieLoading: false,
  exportFasceLoading: false,
};

const setFasceOrarie = (state, action) => {
  return updateObject(state, {
    fasceOrarie: updateObject(state.fasceOrarie, {
      [action.key]: action.value,
    }),
  });
};

const setExportFasceLoading = (state, action) => {
  return updateObject(state, {
    exportFasceLoading: action.value,
  });
};

const setCreateFasceOrarie = (state, action) => {
  return updateObject(state, {
    createFasceOrarie: updateObject(state.createFasceOrarie, {
      [action.key]: action.value,
    }),
  });
};

const setCreateFasceOrarieLoading = (state, action) => {
  return updateObject(state, {
    createFasceOrarieLoading: action.value,
  });
};

const setCurrentFasce = (state, action) => {
  return updateObject(state, {
    selectedFasceOrarie: updateObject(state.selectedFasceOrarie, {
      [action.key]: action.value,
    }),
  });
};

const fasceOrarieReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_FASCE_ORARIE_AND_LOADING:
      return setFasceOrarie(state, action);
    case actionTypes.EXPORT_FASCE_LOADING:
      return setExportFasceLoading(state, action);
    case actionTypes.CREATE_FASCE_ORARIE_DATA:
      return setCreateFasceOrarie(state, action);
    case actionTypes.CREATE_UPDATE_DELETE_FASCE:
      return setCreateFasceOrarieLoading(state, action);
    case actionTypes.GET_CURRENT_FASCE:
      return setCurrentFasce(state, action);
    default:
      return state;
  }
};

export default fasceOrarieReducer;
